(function () {
    'use strict';

    var root = document.documentElement;
    if (root.id !== 'v11m' || !window.matchMedia('(max-width: 767px)').matches) return;

    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canObserve = 'IntersectionObserver' in window;

    function all(selector, scope) {
        return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
    }

    function onFrame(fn) {
        var queued = false;
        return function () {
            if (queued) return;
            queued = true;
            requestAnimationFrame(function () {
                queued = false;
                fn();
            });
        };
    }

    var ARRIVE = [
        '.shopify-section:not(.p-hero) .green-chip.mb-small',
        '.shopify-section:not(.p-hero) .green-chip:has(+ h2.display-4)',
        '.shopify-section:not(.p-hero) h2.display-4',
        '.shopify-section:not(.p-hero) .sub-title',
        '.shopify-section.works .sub-head',
        '.shopify-section.fv4 .sub-head',
        '.shopify-section.fv4 .display-txt',
        '.shopify-section.fv4 .accordion',
        '.shopify-section.f-logos > p',
        '.shopify-section.f-logos > picture',
        '.v8pp .v8pp-card',
        '.v8pp .v8pp-tile',
        '.v8pp .v8pp-unsure',
        '.shopify-section.timeline .chipped-tl > div',
        '.shopify-section.timeline .tl-detail > p',
        '.shopify-section.timeline .tl-note',
        '.shopify-section.numbers .bc-stats',
        '.shopify-section.numbers .bgc-footnote',
        '.shopify-section.targets .zone-tab',
        '.shopify-section.targets .v11zt-outro',
        '.shopify-section.targets .v11zt-cta',
        '.shopify-section.rr2 .rr-paginations',
        '.shopify-section.rr2 .rr-swiper',
        '.shopify-section.rrv4 .d-flex.hide-scroll',
        '.shopify-section.rrv4 .nav-buttons',
        '.shopify-section.works .md',
        '.shopify-section.works .w-card',
        '.shopify-section.nutrients .d8n-pile',
        '.shopify-section.nutrients .nt-thumbs',
        '.shopify-section.nutrients .nt-swiper',
        '.shopify-section.f-bundle-v4 h2.header-1',
        '.shopify-section.f-bundle-v4 .v11m-qb-switch',
        '.shopify-section.f-bundle-v4 .f-cards',
        '.shopify-section.research .video-side',
        '.shopify-section.research .content-side > *',
        '.shopify-section.v11-blood-process .v11bp-head > *',
        '.shopify-section.v11-blood-process .v11bp-notice',
        '.shopify-section.v11-blood-process .v11bc',
        '.shopify-section.v11-blood-process .v11bp-photos > img',
        '.shopify-section.v11-format .v11f-heading',
        '.shopify-section.v11-format .v11f-intro',
        '.shopify-section.v11-format .v11f-card'
    ];

    function arrival() {
        if (calm || !canObserve) return;

        var fold = window.innerHeight * 0.92;
        var targets = [];
        ARRIVE.forEach(function (selector) {
            var found;
            try {
                found = all(selector);
            } catch (e) {
                return;
            }
            found.forEach(function (el) {
                if (targets.indexOf(el) === -1 && el.getBoundingClientRect().top > fold) targets.push(el);
            });
        });
        if (!targets.length) return;

        targets.forEach(function (el) {
            var i = 0;
            var prev = el.previousElementSibling;
            while (prev && i < 4) {
                if (targets.indexOf(prev) !== -1) i++;
                prev = prev.previousElementSibling;
            }
            el.style.setProperty('--v11m-i', i);
            el.setAttribute('data-v11m-reveal', '');
        });
        root.classList.add('v11m--anim');

        var pending = targets.slice();

        function settle(el) {
            el.removeAttribute('data-v11m-reveal');
            el.classList.remove('is-in');
            el.style.removeProperty('--v11m-i');
        }

        var seen = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                seen.unobserve(el);
                pending.splice(pending.indexOf(el), 1);
                el.classList.add('is-in');
                setTimeout(function () {
                    settle(el);
                }, 1200);
            });
        }, { rootMargin: '0px 0px -8% 0px' });
        targets.forEach(function (el) {
            seen.observe(el);
        });

        var FLING = 1.5;
        var lastY = window.scrollY;
        var lastT = performance.now();

        function onScroll() {
            var now = performance.now();
            var y = window.scrollY;
            var speed = Math.abs(y - lastY) / Math.max(now - lastT, 1);
            lastY = y;
            lastT = now;
            if (speed < FLING) return;

            var reach = window.innerHeight * 1.5;
            var due = pending.filter(function (el) {
                return el.getBoundingClientRect().top < reach;
            });
            due.forEach(function (el) {
                seen.unobserve(el);
                pending.splice(pending.indexOf(el), 1);
                settle(el);
            });
            if (!pending.length) window.removeEventListener('scroll', onScroll);
        }

        window.addEventListener('scroll', onScroll, { passive: true });
    }

    var COUNT = [
        '.p-hero .stats-flex strong',
        '.shopify-section.numbers .bcs-item strong',
        '.shopify-section.targets .zc-stat-box strong',
        '.shopify-section.v11-format .v11f-stat'
    ];

    function counting() {
        if (calm || !canObserve) return;

        var figures = [];
        all(COUNT.join(',')).forEach(function (el) {
            if (el.children.length) return;
            var text = el.textContent;
            var match = text.trim().match(/^(\D*)(\d{1,4})(\D*)$/);
            if (match) figures.push({ el: el, text: text, before: match[1], to: +match[2], after: match[3] });
        });
        if (!figures.length) return;

        function run(fig) {
            var el = fig.el;
            var start = null;
            var duration = 1100;
            el.style.minWidth = el.getBoundingClientRect().width + 'px';
            function step(now) {
                if (start === null) start = now;
                var t = Math.min(1, (now - start) / duration);
                var eased = 1 - Math.pow(1 - t, 3);
                if (t < 1) {
                    el.textContent = fig.before + Math.round(fig.to * eased) + fig.after;
                    requestAnimationFrame(step);
                } else {
                    el.textContent = fig.text;
                    el.style.removeProperty('min-width');
                }
            }
            el.textContent = fig.before + '0' + fig.after;
            requestAnimationFrame(step);
        }

        var seen = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                seen.unobserve(entry.target);
                figures.forEach(function (fig) {
                    if (fig.el === entry.target) run(fig);
                });
            });
        }, { threshold: 0.9 });
        figures.forEach(function (fig) {
            seen.observe(fig.el);
        });
    }

    function rail() {
        var box = document.querySelector('.shopify-section.timeline .container');
        if (!box) return;
        var stops = all('.chipped-tl > div', box);
        if (stops.length < 2) return;

        var length = 0;

        function centre(el) {
            var r = el.getBoundingClientRect();
            return r.top + r.height / 2;
        }

        function measure() {
            length = centre(stops[stops.length - 1]) - centre(stops[0]);
            box.style.setProperty('--v11m-rail-h', Math.max(0, Math.round(length)) + 'px');
        }

        function fill() {
            if (calm) {
                box.style.setProperty('--v11m-rail-p', 1);
                stops.forEach(function (stop) {
                    stop.classList.add('is-lit');
                });
                return;
            }
            measure();
            var line = window.innerHeight * 0.6;
            var first = centre(stops[0]);
            var p = length > 0 ? (line - first) / length : 1;
            p = Math.max(0, Math.min(1, p));
            box.style.setProperty('--v11m-rail-p', p.toFixed(4));
            stops.forEach(function (stop) {
                stop.classList.toggle('is-lit', centre(stop) <= line + 1);
            });
        }

        measure();
        fill();
        box.classList.add('v11m-rail');

        var tick = onFrame(fill);
        var near = !canObserve;
        if (canObserve) {
            new IntersectionObserver(function (entries) {
                near = entries[0].isIntersecting;
                if (near) tick();
            }, { rootMargin: '25% 0px' }).observe(box);
        }
        window.addEventListener('scroll', function () {
            if (near) tick();
        }, { passive: true });

        var remeasure = onFrame(function () {
            measure();
            fill();
        });
        if ('ResizeObserver' in window) new ResizeObserver(remeasure).observe(box);
        window.addEventListener('resize', remeasure);
    }

    var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg>';

    function gallery() {
        var strip = document.querySelector('.p-hero.v4h > .d-flex .lf');
        if (!strip) return;
        var cells = all(':scope > *', strip).filter(function (cell) {
            return cell.offsetWidth > 0;
        });
        if (cells.length < 2) return;

        var nav = document.createElement('div');
        nav.className = 'v11m-gnav';
        nav.style.order = window.getComputedStyle(strip).order;

        function arrow(dir, label) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'v11m-arrow v11m-arrow--' + dir;
            button.setAttribute('aria-label', label);
            button.innerHTML = ARROW;
            if (dir === 'prev') button.firstChild.style.transform = 'scaleX(-1)';
            return button;
        }

        var prev = arrow('prev', 'Previous picture');
        var next = arrow('next', 'Next picture');
        var dotRow = document.createElement('div');
        dotRow.className = 'v11m-dots';
        dotRow.setAttribute('aria-hidden', 'true');
        var dots = cells.map(function () {
            var dot = document.createElement('span');
            dotRow.appendChild(dot);
            return dot;
        });
        var status = document.createElement('p');
        status.className = 'visually-hidden';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        var spoken = false;
        nav.appendChild(prev);
        nav.appendChild(dotRow);
        nav.appendChild(next);
        nav.appendChild(status);
        strip.parentNode.insertBefore(nav, strip.nextSibling);

        var current = -1;

        function centreOf(rect) {
            return rect.left + rect.width / 2;
        }

        function go(i) {
            i = Math.max(0, Math.min(cells.length - 1, i));
            var s = strip.getBoundingClientRect();
            var c = cells[i].getBoundingClientRect();
            strip.scrollTo({ left: strip.scrollLeft + centreOf(c) - centreOf(s), behavior: calm ? 'auto' : 'smooth' });
        }

        prev.addEventListener('click', function () {
            spoken = true;
            go(current - 1);
        });
        next.addEventListener('click', function () {
            spoken = true;
            go(current + 1);
        });

        var follow = onFrame(function () {
            var mid = centreOf(strip.getBoundingClientRect());
            var pitch = Math.abs(cells[1].offsetLeft - cells[0].offsetLeft) || 1;
            var best = 0;
            var bestGap = Infinity;
            cells.forEach(function (cell, i) {
                var gap = Math.abs(centreOf(cell.getBoundingClientRect()) - mid);
                cell.style.setProperty('--g', Math.min(1, gap / pitch).toFixed(3));
                if (gap < bestGap) {
                    bestGap = gap;
                    best = i;
                }
            });
            if (best === current) return;
            if (current > -1) dots[current].classList.remove('is-on');
            dots[best].classList.add('is-on');
            if (spoken) status.textContent = 'Picture ' + (best + 1) + ' of ' + cells.length;
            prev.setAttribute('aria-disabled', best === 0 ? 'true' : 'false');
            next.setAttribute('aria-disabled', best === cells.length - 1 ? 'true' : 'false');
            current = best;
        });
        strip.addEventListener('scroll', follow, { passive: true });
        window.addEventListener('resize', follow);
        follow();

        if (calm || !canObserve) return;
        var USED = 'v11m-gallery-used';
        try {
            if (window.sessionStorage.getItem(USED)) return;
        } catch (e) {
        }
        var touched = false;
        function use() {
            touched = true;
            try {
                window.sessionStorage.setItem(USED, '1');
            } catch (e) {
            }
        }
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
            strip.addEventListener(type, use, { passive: true });
        });
        [prev, next].forEach(function (control) {
            control.addEventListener('click', use);
        });

        function glide(to, duration, done) {
            var from = strip.scrollLeft;
            var start = null;
            function step(now) {
                if (touched) return done();
                if (start === null) start = now;
                var t = Math.min(1, (now - start) / duration);
                var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
                strip.scrollLeft = from + (to - from) * eased;
                if (t < 1) requestAnimationFrame(step);
                else done();
            }
            requestAnimationFrame(step);
        }

        var HINTS = [
            { reach: 0.12, out: 520, hold: 220, back: 620, after: 1200 },
            { reach: 0.07, out: 380, hold: 100, back: 480, after: 4500 },
            { reach: 0.07, out: 380, hold: 100, back: 480, after: 4500 }
        ];
        var tries = 0;
        var showing = false;
        var running = false;
        var timer = null;
        var pageMoved = 0;
        window.addEventListener('scroll', function () {
            pageMoved = performance.now();
        }, { passive: true });

        function later(ms) {
            clearTimeout(timer);
            timer = setTimeout(hint, ms);
        }

        function hint() {
            if (touched || running || !showing || tries >= HINTS.length) return;
            if (performance.now() - pageMoved < 700) return later(700);
            var plan = HINTS[tries++];
            var home = strip.scrollLeft;
            running = true;
            strip.style.scrollSnapType = 'none';
            next.classList.remove('v11m-nudge');
            void next.offsetWidth;
            next.classList.add('v11m-nudge');
            glide(home + cells[0].offsetWidth * plan.reach, plan.out, function () {
                setTimeout(function () {
                    glide(home, plan.back, function () {
                        strip.style.removeProperty('scroll-snap-type');
                        running = false;
                        if (!touched && tries < HINTS.length && showing) later(HINTS[tries].after);
                    });
                }, touched ? 0 : plan.hold);
            });
        }

        new IntersectionObserver(function (entries) {
            showing = entries[0].isIntersecting;
            if (!showing) {
                clearTimeout(timer);
                return;
            }
            if (!running && tries < HINTS.length) later(HINTS[tries].after);
        }, { threshold: 0.6 }).observe(strip);
    }

    function reviewsFold() {
        var band = document.querySelector('[id$="__1770634183035d7c29"]');
        if (!band || window.getComputedStyle(band).display === 'none') return;
        var block = band.querySelector('.shopify-app-block') || band.firstElementChild;
        if (!block) return;

        var FOLD = 720;
        var open = false;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'v11m-fold-btn';
        button.textContent = 'Read more reviews';
        button.hidden = true;
        block.parentNode.insertBefore(button, block.nextSibling);
        block.style.setProperty('--v11m-fold-h', FOLD + 'px');

        function check() {
            if (open) return;
            var tall = block.scrollHeight > FOLD + 120;
            block.classList.toggle('v11m-fold', tall);
            button.hidden = !tall;
        }

        button.addEventListener('click', function () {
            open = true;
            block.style.setProperty('--v11m-fold-h', block.scrollHeight + 'px');
            block.classList.add('is-open');
            button.hidden = true;
            setTimeout(function () {
                block.classList.remove('v11m-fold', 'is-open');
                block.style.removeProperty('--v11m-fold-h');
            }, calm ? 0 : 650);
        });

        check();
        if ('ResizeObserver' in window) {
            var inner = block.firstElementChild || block;
            new ResizeObserver(check).observe(inner);
        } else {
            window.addEventListener('load', check);
        }
    }

    function header() {
        var head = document.querySelector('header');
        var row = head && head.querySelector('.header-container');
        if (!row) return;
        var bar = document.querySelector('.sticky-cart.d8h-sticky');

        var GAP = 8;
        var rowTop = 0;
        var rowFoot = 0;
        function measure() {
            var h = head.getBoundingClientRect();
            var r = row.getBoundingClientRect();
            rowTop = Math.max(0, r.top - h.top);
            rowFoot = Math.max(rowTop, r.bottom - h.top);
            head.style.setProperty('--v11m-row-foot', Math.round(rowFoot) + 'px');
        }

        function busy() {
            return !!document.querySelector('.main-menu.active, .search-panel.active, #cart-container.active');
        }

        function past() {
            return bar ? bar.classList.contains('active') : window.pageYOffset > window.innerHeight;
        }

        function shown() {
            return -Math.max(0, rowTop - GAP);
        }

        function away() {
            return -(rowFoot + 4);
        }

        var y0 = Math.max(0, window.pageYOffset);
        var at = 0;
        var way = 0;
        var idle = null;
        var gliding = 0;

        function hang(offset) {
            if (bar) bar.style.setProperty('--v11m-bar-top', Math.round(Math.max(0, rowFoot + offset) + GAP) + 'px');
        }

        function paint() {
            head.style.transform = at ? 'translate3d(0, ' + at.toFixed(1) + 'px, 0)' : '';
            hang(at);
        }

        function follow() {
            if (performance.now() > gliding) {
                head.classList.remove('v11m-head-settle');
                hang(at);
                return;
            }
            hang(new DOMMatrix(window.getComputedStyle(head).transform).m42);
            requestAnimationFrame(follow);
        }

        function glide(to) {
            if (to === at) return;
            at = to;
            head.classList.add('v11m-head-settle');
            head.style.transform = at ? 'translate3d(0, ' + at.toFixed(1) + 'px, 0)' : '';
            var running = performance.now() < gliding;
            gliding = performance.now() + 400;
            if (!running) requestAnimationFrame(follow);
        }

        function settle() {
            if (busy() || !past()) return;
            if (at >= shown() - 0.5 || at <= away() + 0.5) return;
            glide(way > 0 ? away() : shown());
        }

        function track() {
            var y = Math.max(0, window.pageYOffset);
            var dy = y - y0;
            y0 = y;
            head.classList.toggle('v11m-head-lifted', y > 2);
            if (busy()) return;
            if (!past()) {
                if (at !== 0) glide(0);
                return;
            }
            if (performance.now() < gliding) {
                at = new DOMMatrix(window.getComputedStyle(head).transform).m42;
                gliding = 0;
                head.classList.remove('v11m-head-settle');
            }
            if (dy) way = dy > 0 ? 1 : -1;
            at = Math.max(away(), Math.min(Math.max(shown(), at), at - dy));
            paint();
            clearTimeout(idle);
            idle = setTimeout(settle, 140);
        }

        measure();
        head.classList.toggle('v11m-head-lifted', y0 > 2);
        paint();
        window.addEventListener('scroll', onFrame(track), { passive: true });
        window.addEventListener('resize', onFrame(function () {
            measure();
            paint();
        }));

        document.addEventListener('click', function () {
            setTimeout(function () {
                if (busy()) {
                    at = 0;
                    gliding = 0;
                    head.classList.remove('v11m-head-settle');
                    paint();
                } else if (past() && at > shown()) {
                    glide(shown());
                }
            }, 0);
        }, true);
    }

    function tabs() {
        var contents = all('.p-hero .toggle-item > .toggle-content');
        if (!contents.length) return;

        function measure(content) {
            content.style.setProperty('--v11m-tab-h', (content.scrollHeight + 2) + 'px');
        }

        contents.forEach(function (content) {
            measure(content);
            all('img', content).forEach(function (img) {
                if (!img.complete) img.addEventListener('load', function () {
                    measure(content);
                });
            });
            new MutationObserver(function () {
                measure(content);
            }).observe(content.parentNode, { attributes: true, attributeFilter: ['class'] });
        });

        window.addEventListener('resize', onFrame(function () {
            contents.forEach(measure);
        }));
    }

    function ticker() {
        if (calm) return;
        var band = document.querySelector('.shopify-section.f-logos');
        var img = band && band.querySelector('picture img');
        var src = img && img.getAttribute('src');
        if (!src) return;

        var box = document.createElement('div');
        box.className = 'v11m-ticker';
        box.setAttribute('aria-hidden', 'true');
        var track = document.createElement('div');
        track.className = 'v11m-ticker-track';
        [0, 1].forEach(function () {
            var copy = document.createElement('img');
            copy.src = src;
            copy.alt = '';
            copy.decoding = 'async';
            track.appendChild(copy);
        });
        box.appendChild(track);

        track.firstChild.addEventListener('load', function () {
            band.insertBefore(box, img.closest('picture').nextSibling);
            band.classList.add('v11m-ticking');
        });

        if (canObserve) {
            new IntersectionObserver(function (entries) {
                box.classList.toggle('is-paused', !entries[0].isIntersecting);
            }).observe(band);
        }
    }

    function studyGauges() {
        var card = document.querySelector('.shopify-section.numbers .bg-capsule');
        if (!card) return false;
        var items = all('.bcs-item', card);
        var values = items.map(function (item) {
            var strong = item.querySelector('strong');
            var m = strong && strong.textContent.trim().match(/^(\d{1,3})%$/);
            return m ? Math.min(100, +m[1]) : NaN;
        });
        if (!items.length || items.length > 4 || values.some(isNaN)) return false;
        card.classList.add('v11m-gauged');

        var NS = 'http://www.w3.org/2000/svg';
        items.forEach(function (item, i) {
            var svg = document.createElementNS(NS, 'svg');
            svg.setAttribute('class', 'v11m-gauge');
            svg.setAttribute('viewBox', '0 0 100 100');
            svg.setAttribute('aria-hidden', 'true');
            ['track', 'arc'].forEach(function (kind) {
                var c = document.createElementNS(NS, 'circle');
                c.setAttribute('class', kind);
                c.setAttribute('cx', 50);
                c.setAttribute('cy', 50);
                c.setAttribute('r', 46);
                c.setAttribute('pathLength', 100);
                if (kind === 'arc') {
                    c.style.setProperty('--i', i);
                    c.style.setProperty('--off', String(100 - values[i]));
                }
                svg.appendChild(c);
            });
            item.insertBefore(svg, item.firstChild);
        });

        var video = card.querySelector('video');
        if (video) {
            video.pause();
            video.removeAttribute('autoplay');
            video.preload = 'none';
            all('source', video).forEach(function (source) {
                source.remove();
            });
            video.load();
        }

        var stats = card.querySelector('.bc-stats');
        if (calm || !canObserve) {
            stats.classList.add('is-drawn');
            return true;
        }
        var seen = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            seen.disconnect();
            stats.classList.add('is-drawn');
        }, { threshold: 0.6 });
        seen.observe(stats);
        return true;
    }

    function film() {
        if (studyGauges()) return;

        if (calm || !canObserve) return;
        all('.shopify-section.numbers .bg-capsule video').forEach(function (video) {
            video.muted = true;
            new IntersectionObserver(function (entries) {
                if (!entries[0].isIntersecting || !video.paused) return;
                var played = video.play();
                if (played && played.catch) played.catch(function () {});
            }, { threshold: 0.25 }).observe(video);
        });
    }

    function zones() {
        var band = document.querySelector('.shopify-section.targets.v11zt');
        if (!band) return;
        var tabs = all('.zone-tab', band);
        var cards = all('.zone-cards > .zone-card', band);
        if (tabs.length < 2 || cards.length !== tabs.length) return;

        function activeCard() {
            for (var i = 0; i < cards.length; i++) {
                if (cards[i].classList.contains('active')) return cards[i];
            }
            return null;
        }

        function measure() {
            band.classList.add('v11m-zone-still');
            var tallest = 0;
            cards.forEach(function (card) {
                card.style.height = 'auto';
                tallest = Math.max(tallest, card.offsetHeight);
                card.style.height = '';
            });
            band.style.setProperty('--zh', Math.ceil(tallest) + 'px');
            band.classList.add('v11m-zoned');
            void band.offsetHeight;
            requestAnimationFrame(function () {
                band.classList.remove('v11m-zone-still');
            });
        }

        measure();
        window.addEventListener('load', measure);
        var lastWidth = window.innerWidth;
        window.addEventListener('resize', onFrame(function () {
            if (window.innerWidth === lastWidth) return;
            lastWidth = window.innerWidth;
            measure();
        }));

        var headEdge = 0;
        function insets() {
            var row = document.querySelector('header .header-container');
            var bar = document.querySelector('.sticky-cart.active');
            var rowBottom = row ? row.getBoundingClientRect().bottom : 0;
            if (rowBottom > 0) headEdge = rowBottom;
            var b = bar ? bar.getBoundingClientRect() : null;
            var low = !!b && b.top > window.innerHeight / 2;
            var hung = b && !low ? b.bottom - Math.max(0, rowBottom) : 0;
            return {
                now: Math.max(0, rowBottom, b && !low ? b.bottom : 0),
                down: hung,
                up: headEdge + hung,
                foot: low ? window.innerHeight - b.top : 0
            };
        }

        function inView(r, inset) {
            var floor = window.innerHeight - inset.foot;
            var room = floor - inset.now;
            if (r.top < inset.now - 1) return false;
            if (r.height <= room) return r.bottom <= floor + 1;
            return Math.min(r.bottom, floor) - r.top >= room * 0.7;
        }

        function reveal() {
            var card = activeCard();
            if (!card) return;
            var r = card.getBoundingClientRect();
            var inset = insets();
            if (inView(r, inset)) return;
            var top = r.bottom > window.innerHeight - inset.foot ? inset.down : inset.up;
            var room = window.innerHeight - inset.foot - top;
            var lead = r.height <= room - 24 ? (room - r.height) / 2 : 12;
            window.scrollTo({ top: window.pageYOffset + r.top - top - lead, behavior: calm ? 'auto' : 'smooth' });
        }

        var settle = null;
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                clearTimeout(settle);
                settle = setTimeout(reveal, calm ? 0 : 640);
            });
        });

        var x0 = null;
        var y0 = null;
        cards.forEach(function (card) {
            card.addEventListener('touchstart', function (e) {
                x0 = e.touches[0].clientX;
                y0 = e.touches[0].clientY;
            }, { passive: true });
            card.addEventListener('touchend', function (e) {
                if (x0 === null) return;
                var dx = e.changedTouches[0].clientX - x0;
                var dy = e.changedTouches[0].clientY - y0;
                x0 = null;
                if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
                var next = cards.indexOf(card) + (dx < 0 ? 1 : -1);
                if (next >= 0 && next < tabs.length) tabs[next].click();
            }, { passive: true });
        });
    }

    function realResults() {
        var band = document.querySelector('.shopify-section.rr2');
        var slider = band && (band.querySelector('.rr-swiper') || {}).swiper;
        var thumbs = band && (band.querySelector('.rr-thumbs') || {}).swiper;
        if (!slider || !slider.params) return;

        if (thumbs && thumbs.params) {
            thumbs.params.slidesPerView = Math.min(4, thumbs.slides.length);
            thumbs.update();
        }

        var auto = slider.autoplay;
        if (!auto || !slider.params.autoplay) return;
        if (calm) {
            auto.stop();
            return;
        }
        slider.params.autoplay.delay = 7000;
        slider.params.autoplay.disableOnInteraction = true;
        auto.stop();

        var ring = function (fill) {
            all('.rr-thumb', band).forEach(function (thumb) {
                thumb.style.setProperty('--rr-p', '0');
            });
            var active = band.querySelector('.rr-thumbs .swiper-slide-thumb-active .rr-thumb');
            if (active) active.style.setProperty('--rr-p', fill.toFixed(3));
        };
        slider.on('autoplayTimeLeft', function (s, time, left) {
            ring(1 - left);
        });
        slider.on('slideChange', function () {
            ring(0);
        });

        var stopped = false;
        var stopForGood = function () {
            if (stopped) return;
            stopped = true;
            auto.stop();
            ring(1);
        };
        slider.on('touchStart', stopForGood);
        if (thumbs && thumbs.el) thumbs.el.addEventListener('click', stopForGood);

        if (!canObserve) return;
        new IntersectionObserver(function (entries) {
            if (stopped) return;
            if (entries[0].isIntersecting) {
                if (!auto.running) auto.start();
            } else if (auto.running) {
                auto.stop();
            }
        }, { threshold: 0.5 }).observe(slider.el);
    }

    function ingredients() {
        var band = document.querySelector('.shopify-section.nutrients');
        var slider = band && (band.querySelector('.nt-swiper') || {}).swiper;
        var thumbs = band && (band.querySelector('.nt-thumbs') || {}).swiper;
        var nav = band && band.querySelector('.nt-paginations');
        if (!slider || !slider.params || !nav) return;

        var count = all('.nt-swiper .swiper-slide:not(.swiper-slide-duplicate)', band).length;
        var row = document.createElement('div');
        row.className = 'v11m-dots';
        row.setAttribute('aria-hidden', 'true');
        var dots = [];
        for (var i = 0; i < count; i++) {
            var dot = document.createElement('span');
            row.appendChild(dot);
            dots.push(dot);
        }
        var next = nav.querySelector('.swiper-button-next');
        nav.insertBefore(row, next);

        function centreTab() {
            if (!thumbs || !thumbs.slides) return;
            var tab = thumbs.slides[slider.realIndex];
            if (!tab) return;
            var pad = parseFloat(window.getComputedStyle(thumbs.el).paddingLeft) || 0;
            var target = -(tab.offsetLeft + tab.offsetWidth / 2 - (thumbs.el.clientWidth / 2 - pad));
            target = Math.max(thumbs.maxTranslate(), Math.min(thumbs.minTranslate(), target));
            thumbs.translateTo(target, calm ? 0 : 450);
        }

        function update() {
            dots.forEach(function (dot, n) {
                dot.classList.toggle('is-on', n === slider.realIndex);
            });
            centreTab();
        }

        slider.on('slideChange', update);
        update();
    }

    function bundles() {
        var band = document.querySelector('.shopify-section.f-bundle-v4 .f-bundle');
        var strip = band && band.querySelector('.f-cards');
        var heading = band && band.querySelector('.header-1');
        if (!strip || !heading) return;
        var cards = all('.f-card', strip);
        if (!cards.length) return;

        var groups = [];
        var groupOf = cards.map(function (card, n) {
            var label = card.querySelector('.gender');
            var name = label ? label.textContent.trim() : '';
            var last = groups[groups.length - 1];
            if (!last || last.name !== name) groups.push({ name: name, first: n });
            return groups.length - 1;
        });
        if (groups.length < 2 || groups.some(function (g) { return !g.name; })) return;

        var bar = document.createElement('div');
        bar.className = 'v11m-qb-switch';
        bar.setAttribute('role', 'group');
        bar.setAttribute('aria-label', heading.textContent.trim());
        var thumb = document.createElement('span');
        thumb.className = 'v11m-qb-thumb';
        var lit = document.createElement('span');
        lit.className = 'v11m-qb-lit';
        thumb.setAttribute('aria-hidden', 'true');
        lit.setAttribute('aria-hidden', 'true');

        function stops() {
            var pad = parseFloat(window.getComputedStyle(strip).paddingLeft) || 0;
            var max = strip.scrollWidth - strip.clientWidth;
            var origin = strip.getBoundingClientRect().left - strip.scrollLeft;
            return cards.map(function (card) {
                return Math.max(0, Math.min(max, card.getBoundingClientRect().left - origin - pad));
            });
        }

        var buttons = groups.map(function (group) {
            var button = document.createElement('button');
            button.type = 'button';
            button.textContent = group.name;
            button.addEventListener('click', function () {
                strip.scrollTo({ left: stops()[group.first], behavior: calm ? 'auto' : 'smooth' });
            });
            bar.appendChild(button);
            lit.appendChild(document.createElement('span')).setAttribute('data-label', group.name);
            return button;
        });
        bar.appendChild(thumb);
        bar.appendChild(lit);

        function place() {
            var at = stops();
            var left = strip.scrollLeft;
            var f = groupOf[cards.length - 1];
            for (var n = 0; n < cards.length - 1; n++) {
                if (left < at[n + 1]) {
                    var span = at[n + 1] - at[n];
                    var t = span > 0 ? Math.max(0, (left - at[n]) / span) : 1;
                    f = groupOf[n] + (groupOf[n + 1] - groupOf[n]) * t;
                    break;
                }
            }
            var i = Math.min(Math.floor(f), buttons.length - 1);
            var mix = f - i;
            var from = buttons[i];
            var to = buttons[Math.min(i + 1, buttons.length - 1)];
            var width = from.offsetWidth + (to.offsetWidth - from.offsetWidth) * mix;
            var x = from.offsetLeft + (to.offsetLeft - from.offsetLeft) * mix;
            thumb.style.width = width + 'px';
            thumb.style.transform = 'translateX(' + x + 'px)';
            var clip = 'inset(0 ' + Math.max(0, lit.offsetWidth - (x - lit.offsetLeft) - width) + 'px 0 ' + (x - lit.offsetLeft) + 'px round 99px)';
            lit.style.webkitClipPath = clip;
            lit.style.clipPath = clip;
            var on = Math.round(f);
            buttons.forEach(function (button, k) {
                button.setAttribute('aria-pressed', k === on ? 'true' : 'false');
            });
        }

        heading.insertAdjacentElement('afterend', bar);
        band.classList.add('v11m-qbs');
        place();
        var queue = onFrame(place);
        strip.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    }

    function reviewCards() {
        var band = document.querySelector('.shopify-section.rrv4');
        var row = band && band.querySelector('.d-flex.hide-scroll');
        var nav = band && band.querySelector('.nav-buttons');
        if (!row || !nav) return;
        var real = all('.result-card', row);
        if (real.length < 2) return;
        var N = real.length;

        all('.result-card p br:not(.d-md-block)', row).forEach(function (br) {
            br.parentNode.replaceChild(document.createTextNode(' '), br);
        });

        function copy(card) {
            var twin = card.cloneNode(true);
            twin.classList.add('v11m-rv-copy');
            twin.setAttribute('aria-hidden', 'true');
            if (twin.matches('a')) twin.setAttribute('tabindex', '-1');
            all('a, button', twin).forEach(function (el) {
                el.setAttribute('tabindex', '-1');
            });
            return twin;
        }
        var before = real.map(copy);
        var after = real.map(copy);
        before.forEach(function (twin) {
            row.insertBefore(twin, real[0]);
        });
        after.forEach(function (twin) {
            row.appendChild(twin);
        });
        var cards = before.concat(real, after);

        var count = document.createElement('span');
        count.className = 'v11m-rv-count';
        var current = document.createElement('b');
        count.appendChild(current);
        count.appendChild(document.createElement('span')).textContent = ' / ' + N;
        var track = document.createElement('span');
        track.className = 'v11m-rv-track';
        track.setAttribute('aria-hidden', 'true');
        var thumb = document.createElement('i');
        track.appendChild(thumb);
        nav.insertBefore(track, nav.firstChild);
        nav.insertBefore(count, track);

        function stops() {
            var max = row.scrollWidth - row.clientWidth;
            return cards.map(function (card) {
                return Math.max(0, Math.min(max, card.offsetLeft + card.offsetWidth / 2 - row.clientWidth / 2));
            });
        }

        var shown = -1;
        function roll(n, dir) {
            if (n === shown) return;
            var leaving = current.lastElementChild;
            var coming = document.createElement('span');
            coming.textContent = String(n + 1);
            shown = n;
            if (!leaving || calm) {
                current.textContent = '';
                current.appendChild(coming);
                return;
            }
            coming.style.transform = 'translateY(' + dir * 100 + '%)';
            coming.style.opacity = '0';
            current.appendChild(coming);
            while (current.children.length > 2) current.removeChild(current.firstElementChild);
            void coming.offsetWidth;
            leaving.style.transform = 'translateY(' + -dir * 100 + '%)';
            leaving.style.opacity = '0';
            coming.style.transform = '';
            coming.style.opacity = '';
            setTimeout(function () {
                if (leaving.parentNode) leaving.parentNode.removeChild(leaving);
            }, 450);
        }

        function nearest(at) {
            var best = 0;
            at.forEach(function (stop, n) {
                if (Math.abs(stop - row.scrollLeft) < Math.abs(at[best] - row.scrollLeft)) best = n;
            });
            return best;
        }

        var lastRaw = -1;
        var focus = [];
        function place() {
            var at = stops();
            var raw = nearest(at);
            roll(raw % N, raw >= lastRaw ? 1 : -1);
            lastRaw = raw;
            var pitch = cards[1].offsetLeft - cards[0].offsetLeft;
            cards.forEach(function (card, k) {
                var f = Math.min(1, Math.abs(at[k] - row.scrollLeft) / pitch).toFixed(3);
                if (focus[k] === f) return;
                focus[k] = f;
                card.style.setProperty('--rv-f', f);
            });
            var p = Math.round((row.scrollLeft - at[N]) / pitch * 100) / 100;
            var along = Math.min(1, (((p % N) + N) % N) / (N - 1));
            var room = track.clientWidth;
            var size = Math.max(room / N, 16);
            thumb.style.width = size + 'px';
            thumb.style.transform = 'translateX(' + along * (room - size) + 'px)';
        }

        function step(by) {
            var at = stops();
            var n = Math.max(0, Math.min(cards.length - 1, nearest(at) + by));
            row.scrollTo({ left: at[n], behavior: calm ? 'auto' : 'smooth' });
        }

        function wrap() {
            var at = stops();
            var n = nearest(at);
            if (n >= N && n < 2 * N) return;
            lastRaw = n < N ? n + N : n - N;
            row.scrollTo({ left: at[lastRaw], behavior: 'instant' });
        }

        band.addEventListener('click', function (e) {
            var button = e.target.closest && e.target.closest('.nav-btn');
            if (!button || !nav.contains(button)) return;
            e.preventDefault();
            e.stopPropagation();
            step(button.classList.contains('rt') ? 1 : -1);
        }, true);

        band.classList.add('v11m-rv');
        row.scrollTo({ left: stops()[N], behavior: 'instant' });
        place();
        var queue = onFrame(place);
        row.addEventListener('scroll', queue, { passive: true });
        var rest = null;
        row.addEventListener('scroll', function () {
            clearTimeout(rest);
            rest = setTimeout(wrap, 180);
        }, { passive: true });
        var width = window.innerWidth;
        window.addEventListener('resize', onFrame(function () {
            if (window.innerWidth === width) return;
            width = window.innerWidth;
            var n = nearest(stops());
            row.scrollTo({ left: stops()[n], behavior: 'instant' });
            place();
        }));
    }

    function founder() {
        if (calm || !canObserve) return;
        var frame = document.querySelector('.shopify-section.research .video-side');
        if (!frame || !frame.querySelector('img')) return;
        var REACH = 10;

        function drift() {
            var box = frame.getBoundingClientRect();
            var view = window.innerHeight;
            var at = (view / 2 - (box.top + box.height / 2)) / (view / 2 + box.height / 2);
            at = Math.max(-1, Math.min(1, at));
            frame.style.setProperty('--rs-drift', (at * REACH).toFixed(2) + 'px');
        }

        var queue = onFrame(drift);
        new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                drift();
                window.addEventListener('scroll', queue, { passive: true });
            } else {
                window.removeEventListener('scroll', queue);
            }
        }, { rootMargin: '20% 0px' }).observe(frame);
    }

    function faqs() {
        var band = document.querySelector('.shopify-section.fv4');
        if (!band) return;

        all('.faqs-acc .accordion', band).forEach(function (item) {
            var video = item.querySelector('.acc-content .video[data-id]');
            var head = item.querySelector('.acc-head');
            if (!video || !head) return;
            item.classList.add('v11m-fq-vid');
            var title = video.querySelector('h3');
            if (title) {
                title.classList.add('v11m-fq-cap');
                video.parentNode.insertBefore(title, video.nextSibling);
            }
            head.style.setProperty('--fq-thumb', 'url("https://i.ytimg.com/vi/' + encodeURIComponent(video.getAttribute('data-id')) + '/mqdefault.jpg")');
        });

        band.addEventListener('click', function (e) {
            var head = e.target.closest && e.target.closest('.acc-head');
            if (!head || !band.contains(head)) return;
            var item = head.parentElement;
            var was = head.getBoundingClientRect().top;
            var until = performance.now() + (calm ? 0 : 520);

            (function hold() {
                var moved = head.getBoundingClientRect().top - was;
                if (Math.abs(moved) > 0.5) window.scrollBy(0, moved);
                if (performance.now() < until) {
                    requestAnimationFrame(hold);
                    return;
                }
                if (!item.classList.contains('active')) return;
                var answer = item.querySelector('.acc-content');
                var over = answer.getBoundingClientRect().bottom - (window.innerHeight - 24);
                if (over > 0) window.scrollBy({ top: over, behavior: calm ? 'auto' : 'smooth' });
            })();
        }, true);
    }

    function start() {
        [bundles, reviewCards, arrival, counting, rail, gallery, reviewsFold, header, tabs, ticker, film, zones, realResults, ingredients, founder, faqs].forEach(function (part) {
            try {
                part();
            } catch (e) {
                if (window.console) console.warn('v11-mobile:', part.name, e);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
}());
